var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembershipOrangeStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56275 13.6807C6.727 14.1091 7.43863 14.105 7.59781 13.6746C8.05959 12.4251 8.81808 10.7197 9.79988 9.72635C10.7817 8.73305 12.4782 7.95465 13.722 7.47847C14.1508 7.31421 14.1467 6.60265 13.716 6.4434C12.4667 5.98172 10.7612 5.22311 9.76797 4.2413C8.77468 3.2595 7.99639 1.56304 7.5201 0.319262C7.35592 -0.109563 6.64429 -0.105422 6.48504 0.325285C6.02336 1.57452 5.26476 3.27992 4.28296 4.27322C3.30116 5.26652 1.60471 6.04492 0.360582 6.52111C-0.0678769 6.68536 -0.0637368 7.39692 0.366604 7.55617C1.61619 8.01785 3.32158 8.77646 4.31487 9.75827C5.30817 10.7401 6.08656 12.4365 6.56275 13.6807Z",
    fill: "#C2B58C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipOrangeStar);
export default __webpack_public_path__ + "static/media/membership-orange-star.37cc7b38cd4080a3531a4f258ad5a45a.svg";
export { ForwardRef as ReactComponent };